import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

export const useGetLocalCartItems = (productId: number) => {
	const localItems = useSelector(selectors.localCartItemsNew)
	const correctItems = useMemo(() => localItems[productId] || [], [productId, localItems])

	return correctItems
}
